import React, { Component, Fragment } from "react";
import "./App.css";
import axios from "axios";
import { getToken, logout } from "./adalConfig";
import { Spinner } from "./components/Spinner";

import Routes from "./Routes";

import { LoggedUserContext } from "./LoggedUserContext";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

axios.interceptors.response.use(
  function(response) {
    response.headers["X-Frame-Options"] = "DENY";
    return response;
  },
  function(error) {
    return Promise.reject(error);
  }
);

class App extends Component {
  state = {
    user: {},
    loading: true,
  };

  componentDidMount() {
    axios
      .get(`${process.env.REACT_APP_API_URL}/AzureAdIdentityAPI/GetMail`, {
        headers: { Authorization: `Bearer ${getToken()}` },
      })
      .then((res) => {
        if(res.data === ''){
          throw new Error("Email not found");
        }
        axios
          /*.get(
            `${process.env.REACT_APP_API_URL}/UserAPI/GetUserGPNPerEmail/${res.data}`,
          */
          .post(
            `${process.env.REACT_APP_API_URL}/UserAPI/GetUserGPNPerEmail`,
            {
              email: res.data
            },
            {
              headers: { Authorization: `Bearer ${getToken()}` },
            }
          )
          .then((gpn) => {
            if(gpn.data.items.length === 0){
              throw new Error('Your user was not found in the data warehouse');
            }

            axios.get(`${process.env.REACT_APP_API_URL}/UserAPI/GetUsersPerId`, {headers: { Authorization: `Bearer ${getToken()}` }})
            .then((res) => {
              if(res.data.items.length > 0){
                this.setState({ user: res.data.items[0], loading: false });
              }else{
                this.setState({ user: {userId: "NoId" }, loading: false});
              }
            })

            
          })
          .catch((error) =>{
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving your user from the database",
              ////text: error,
              confirmButtonColor: "#FFE600",
              confirmButtonText:
                        "<div style='color: black'>OK</div>",
            }).then(() => {
              logout();
            });
          })
      })
      .catch((error) => {
        MySwal.fire({
          icon: "error",
          title: "An error has occurred while retrieving your user from the database",
          ////text: error,
          confirmButtonColor: "#FFE600",
          confirmButtonText:
                    "<div style='color: black'>OK</div>",
        }).then(() => {
          logout();
        });
      })
  }

  render() {
    return (
      <Fragment>
        {this.state.loading ? (
          <div>
            <Spinner />
          </div>
        ) : (
          <div className="App">
            <LoggedUserContext.Provider value={this.state.user}>
              <Routes />
            </LoggedUserContext.Provider>
          </div>
        )}
      </Fragment>
    );
  }
}

export default App;
